import { withAuthenticator } from '@aws-amplify/ui-react'
import { Deck } from '@chrisdunne-com/chrisdunne-types'
import React, { useEffect, useState } from 'react'
import { Modal } from 'reactstrap'
import { deleteData, getData } from '../../utils/server'
import { Header } from '../../components/header'
import { Sidebar } from '../../components/sidebar'
import AddDeckModal from './flash-cards-modal'
import { Table } from '../../components/table'
import { Footer } from '../../components/footer'

function Decks() {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [modalDeck, setModalDeck] = useState<Deck>()
  const [decks, setDecks] = useState<any[]>([])

  useEffect(() => {
    if (!success && !error) {
      getData('/flashcard').then(
        (result: any) => {
          setSuccess(true)
          setDecks(result)
        },
        (error: any) => {
          setError(error)
        },
      )
    }
  })

  function tog_backdrop(item?: Deck) {
    setModalDeck(undefined)
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()

    if (item) {
      setModalDeck(item)
    }
  }

  function put_deck(deck: Deck) {
    if (decks.some((x) => x.slug === deck.slug)) {
      const item = decks.findIndex((x) => x.id === deck.slug)
      decks[item] = deck
    } else {
      setDecks([...decks, deck])
    }
  }

  function removeBodyCss() {
    document.body.classList.add('no_padding')
  }

  function delete_item(slug: string) {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Are you sure you want to delete this Deck?') === true) {
      deleteData('/flashcard', slug).then(
        (result: any) => {
          setDecks(decks.filter((deck) => deck.slug !== slug))
        },
        (error: any) => {
          setError(error)
        },
      )
    }
  }

  return (
    <div>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <h4 className="font-size-18">Flash Card Decks</h4>
            <button
              type="button"
              className="btn btn-success float-end"
              onClick={() => {
                tog_backdrop()
              }}
              data-toggle="modal"
              style={{ marginRight: '50px' }}
            >
              Add New
            </button>
            <Modal
              size="lg"
              isOpen={modal_backdrop}
              toggle={() => {
                tog_backdrop()
              }}
              backdrop={'static'}
              id="staticBackdrop"
            >
              <AddDeckModal
                setmodal_backdrop={setmodal_backdrop}
                put_deck={put_deck}
                deck={modalDeck}
              />
            </Modal>
            <Table columns={['Title']}>
              {decks.map((item: Deck, count) => (
                <tr key={count}>
                  <td>{item.title}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        tog_backdrop(item)
                      }}
                      data-toggle="modal"
                    >
                      Update
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-light btn-sm"
                      onClick={() => {
                        delete_item(item.slug)
                      }}
                      data-toggle="modal"
                    >
                      <i className="bx bx-x"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </Table>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export const FlashCards = withAuthenticator(Decks, {
  hideSignUp: true,
  loginMechanisms: ['email'],
})
